/**
 *  Member Module
 */

// Template URLs for member list views
var MEMBER_LIST_TEMPLATES = [
  '/r/static/templates/members/all.html',
  '/r/static/templates/members/deleted.html',
  '/r/static/templates/members/applications.html',
]
var MEMBER_EDIT_TEMPLATE = '/r/static/templates/members/edit.html'

// Helper: Setup page state tracking for list controllers
function setupMemberListPageTracking($scope, $rootScope) {
  // Clear last_page unless returning from edit view
  if (!$rootScope.returning_from_member_edit) {
    $rootScope.last_page = null
  }
  $rootScope.returning_from_member_edit = false

  // Remember current page when navigating to edit view
  var routeChangeListener = $rootScope.$on('$routeChangeStart', function (event, next) {
    if (next && next.$$route && next.$$route.templateUrl === MEMBER_EDIT_TEMPLATE) {
      $rootScope.last_page = $scope.currentPage
    }
  })

  // Clean up listener when controller is destroyed
  $scope.$on('$destroy', function () {
    routeChangeListener()
  })
}

// Helper: Setup return tracking for edit controller
function setupMemberEditReturnTracking($scope, $rootScope) {
  var routeChangeListener = $rootScope.$on('$routeChangeStart', function (event, next) {
    if (next && next.$$route && MEMBER_LIST_TEMPLATES.indexOf(next.$$route.templateUrl) !== -1) {
      $rootScope.returning_from_member_edit = true
    }
  })

  // Clean up listener when controller is destroyed
  $scope.$on('$destroy', function () {
    routeChangeListener()
  })
}

angular
  .module('members', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.members.all(), {controller: 'MemberCtrl', templateUrl: '/r/static/templates/members/all.html'})
      .when(CONFIG.url.members.add(), {
        controller: 'MemberEditCtrl',
        templateUrl: '/r/static/templates/members/edit.html',
      })
      .when(CONFIG.url.members.edit(), {
        controller: 'MemberEditCtrl',
        templateUrl: '/r/static/templates/members/edit.html',
      })
      .when(CONFIG.url.members.deleted(), {
        controller: 'MemberDeletedCtrl',
        templateUrl: '/r/static/templates/members/deleted.html',
      })
      .when(CONFIG.url.members.applications(), {
        controller: 'MemberApplicationCtrl',
        templateUrl: '/r/static/templates/members/applications.html',
      })
      .when(CONFIG.url.members.bulkedit(), {
        controller: 'MemberBulkEditCtrl',
        templateUrl: '/r/static/templates/members/bulkedit.html',
      })
      .when(CONFIG.url.members.history(), {
        controller: 'MemberHistoryCtrl',
        templateUrl: '/r/static/templates/members/history.html',
      })
  }])
  .factory('Member', ['$resource', function ($resource) {
    var Member = $resource(
      CONFIG.api('members'),
      {},
      {
        query: {method: 'POST', isArray: false, params: {id: 'all'}},
        stats: {method: 'POST', params: {id: 'get_stats'}},
        results: {method: 'POST', params: {id: 'get_results'}},
        restore: {method: 'POST', isArray: false, params: {id: 'restore'}},
        bulkremove: {method: 'POST', isArray: false, params: {id: 'bulkremove'}},
        bulkrestore: {method: 'POST', isArray: false, params: {id: 'bulkrestore'}},
        bulkupdate: {method: 'POST', params: {id: 'bulkupdate'}},
        quicksearch: {method: 'POST', isArray: false, params: {id: 'quicksearch'}},
        supersearch: {method: 'POST', isArray: false, params: {id: 'supersearch'}},
        bulkget: {method: 'POST', params: {id: 'bulkget'}},
        member_history: {method: 'POST', isArray: true, params: {id: 'get_history'}},
        apply: {method: 'POST', isArray: false, params: {id: 'apply'}},
        approve: {method: 'POST', isArray: false, params: {id: 'approve'}},
        delete_permanently: {method: 'POST', isArray: false, params: {id: 'delete_permanently'}},
        clear_mfa: {method: 'POST', isArray: false, params: {id: 'clear_mfa'}},
        send_mfa_reset_code: {method: 'POST', isArray: false, params: {id: 'send_mfa_reset_code'}},
        close_site_admin_sessions: {method: 'POST', isArray: false, params: {id: 'close_site_admin_sessions'}},
      },
    )
    return Member
  }])

/* Controllers */

angular.module('members').controller('MemberCtrl', ['$scope', '$rootScope', 'Member', '$route', '$location', function ($scope, $rootScope, Member, $route, $location) {
  $scope.utils.setPageTitle(_('breadcrumb_members'))
  $scope.utils.setPageID('members')

  setupMemberListPageTracking($scope, $rootScope)

  $scope.paginate = function (page) {
    $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
  }

  $scope.bulkremove = function () {
    Member.bulkremove(
      {
        filter: $scope.filter_to_post,
      },
      // success handler
      function (data) {
        $scope.notify.set($scope, _('HTML_notification_members_removed', {_n: data.count, id: data.log_id}))
        $route.reload()
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  $scope.bulkremove_undo = function (id) {
    Member.bulkrestore(
      {
        filter: [{field: 'id', value: id, verb: 'a4fromlogbatch'}],
      },
      // success handler
      function (data) {
        $scope.notify.set($scope, _('HTML_notification_members_removed_undo'))
        $route.reload()
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  $scope.bulkEdit = function () {
    $location.path(CONFIG.url.members.bulkedit(encodeURIComponent(JSON.stringify($scope.filter_to_post))))
  }

  // NB: This is also on MemberDeletedCtrl.
  $scope.str_filter = function () {
    // .replace is for obscure outer-apache bug  (fb:141425)
    return encodeURIComponent(JSON.stringify($scope.filter_to_post)).replace(/%2F/g, '/')
  }

  $scope.$watch('stats', function () {
    if ($scope.stats) {
      $scope.modal = {
        header: _('members_remove_members_confirmation_header'),
        content: _('members_remove_members_confirmation_text', {_n: $scope.stats.result_count}),
        confirmation_btn: _('members_remove_members_btn', {_n: $scope.stats.result_count}),
        callback: $scope.bulkremove,
      }

      // load member application count (after other data)
      Member.stats({}, function (data) {
        // $scope.stats may have been reset to null in the meantime (e.g. the filter
        // re-querying while this request was in flight) - nothing to update in that case
        if ($scope.stats) {
          $scope.stats.result_application_count = data.stats.result_application_count
        }
      })
    }
  })
}])

angular.module('members').controller('MemberDeletedCtrl', ['$scope', '$rootScope', 'Member', 'Field', '$route', function ($scope, $rootScope, Member, Field, $route) {
  $scope.utils.setPageTitle(_('breadcrumb_members_deleted'))
  $scope.utils.setPageID('members')

  setupMemberListPageTracking($scope, $rootScope)

  $scope.paginate = function (page) {
    $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
  }

  $scope.bulkrestore = function () {
    Member.bulkrestore(
      {
        filter: $scope.filter_to_post,
      },
      // success handler
      function (data) {
        $scope.notify.set($scope, _('HTML_notification_members_restored', {_n: data.count, id: data.log_id}))
        for (var i = 0; i < $scope.conditions.length; i++) {
          if ($scope.conditions[i].field == 'id') {
            // TODO: fix this somehow?
            //$scope.conditions.splice(i, 1);
          }
        }
        $route.reload()
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  $scope.bulkrestore_undo = function (id) {
    Member.bulkremove(
      {
        filter: [{field: 'id', value: id, verb: 'a4fromlogbatch'}],
      },
      // success handler
      function (data) {
        $scope.notify.set($scope, _('HTML_notification_members_restored_undo'))
        $route.reload()
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  $scope.export_deleted = function () {
    var f = $scope.filter_to_post
    f.push({field: 'deleted', value: 'yes', verb: 'a4boolequals'})
    window.location = CONFIG.url.members['export'](encodeURIComponent(JSON.stringify(f)).replace(/%2F/g, '/'))
  }

  $scope.delete_permanently = function () {
    Member.delete_permanently(
      {
        filter: $scope.filter_to_post,
      },
      // success handler
      function (data) {
        $scope.notify.set($scope, _('HTML_notification_members_deleted_permanently', {_n: data.count}))
        $route.reload()
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  $scope.set_modal = function (caller) {
    if (caller == 'perm_delete') {
      $scope.modal = {
        header: _('members_permdelete_members_confirmation_header'),
        content: _('members_permdelete_members_confirmation_text', {_n: $scope.stats.result_count}),
        confirmation_btn: _('members_permdelete_members_btn', {_n: $scope.stats.result_count}),
        callback: $scope.delete_permanently,
      }
    } else {
      $scope.modal = {
        header: _('members_restore_members_confirmation_header'),
        content: _('members_restore_members_confirmation_text', {_n: $scope.stats.result_count}),
        confirmation_btn: _('members_restore_members_btn', {_n: $scope.stats.result_count}),
        callback: $scope.bulkrestore,
      }
    }
  }
}])

angular.module('members').controller('MemberApplyCtrl', ['$scope', 'Field', 'Member', function ($scope, Field, Member) {
  $scope.fields = window.a4_web2reg_memberform_fields
  $scope.isApplyForm = true
  $scope.disabled = false

  $scope.apply = a4.saveFactory($scope, function (submitEvt) {
    // let the browser handle the form validation for email
    if (!window.document.forms['application-form'].checkValidity()) {
      $scope._sending = false
      return
    }

    $scope.disabled = true

    var token_num
    try {
      // nodecms
      token_num = $(submitEvt.target)
        .parents('.widget')[0]
        .id.match(/widget-(\w+)/)[1]
    } catch (e) {
      // perlcms
      token_num = $(submitEvt.target)
        .parents('.token-Memberform')[0]
        .id.match(/token-(\d+)/)[1]
    }
    $scope.member._applied_from_token_num = token_num

    a4.trimMemberFields($scope)
    Member.apply(
      {},
      $scope.member,
      // Success
      function () {
        $scope.application_form.$setPristine()
        window.a4_reg2web_memberform_thanks(token_num)
      },
      // Fail
      function (data) {
        $scope.disabled = false
        a4.restErrorFactory($scope)(data)
      },
    )
  })

  $scope.member = new Member()
  a4.loaded($scope)
  // Set new member defaults
  $scope.member.active = true
}])

// list of member applications
angular.module('members').controller('MemberApplicationCtrl', ['$scope', '$rootScope', 'Group', function ($scope, $rootScope, Group) {
  $scope.utils.setPageTitle(_('breadcrumb_members_applications'))
  $scope.utils.setPageID('members')

  setupMemberListPageTracking($scope, $rootScope)

  $scope.paginate = function (page) {
    $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
  }

  $scope.$watch(
    'members',
    function () {
      if (!$scope.members) {
        return
      }

      $.each($scope.members, function (mIdx, m) {
        var member_groups = []
        $.each($scope.groups, function (gIdx, g) {
          if (m[g.name]) {
            member_groups.push(g.label)
          }
        })
        $scope.members[mIdx].str_groups = member_groups.join(', ')
      })

      // str_groups is computed here, after memberFilter's own fetch success handler has
      // already called applySorting() once - re-apply so a sort (persisted or just chosen)
      // by the 'str_groups' column actually takes effect instead of sorting on undefined.
      $scope.applySorting()
    },
    true,
  )
}])

angular
  .module('members')
  .controller(
    'MemberEditCtrl',
    ['$scope', '$rootScope', '$location', '$route', '$routeParams', '$modal', 'Member', 'Field', 'Group', function ($scope, $rootScope, $location, $route, $routeParams, $modal, Member, Field, Group) {
      $scope.isAdmin = true
      $scope.utils.setPageID('members')

      $scope._sending = false

      setupMemberEditReturnTracking($scope, $rootScope)

      $scope.passwordFieldsVisible = false
      $scope.passwordStrength = null

      $scope.newPasswordVisible = false
      $scope.confirmNewPasswordVisible = false

      // NB: Duplicated in updreqs.js
      $scope.showPasswordFields = function () {
        $scope.passwordFieldsVisible = true
      }

      $scope.$watch(
        'member',
        function () {
          if ($scope.member) {
            // Convert string false values to bool before sending, just testing on active for now
            $scope.member.active = $scope.member.active == 'false' || !$scope.member.active ? false : true
          }
          if ($scope.passwordFieldsVisible && ($scope.member.newPassword_ || $scope.member.confirmNewPassword_)) {
            $scope.passwordStrength = a4.getPasswordStrength($scope.member.newPassword_)
          } else {
            $scope.passwordStrength = null
          }
        },
        true,
      )

      $scope.handleRequirednessError = function (data) {
        a4.restErrorFactory($scope)(data)
        const errors = data.data.error
        if (
          Object.values(errors)
            .flat()
            .every((error) => error === '_validation_field_required') &&
          !['firstname', 'lastname'].some((field) => field in errors)
        ) {
          $scope.empty_required_fields = Object.keys(errors).map(
            (field) => $scope.fields.find((f) => f.name === field)?.label,
          )
          $modal({
            template: '/r/static/templates/members/modal-confirm-save.html',
            persist: true,
            show: true,
            backdrop: 'static',
            scope: $scope,
          })
        }
      }

      // If we are editing then get the Member, else create empty one
      if ($routeParams.id) {
        $scope.member = {id: -1} // to not show "New Member" while the member data is loading
        Member.get(
          {
            id: $routeParams.id,
            // active/inactive, pending, deleted
            any_state: true,
          },
          // success handler
          function (member) {
            $scope.member = member
            $scope.utils.setPageTitle($scope.member.fullname_)
            $scope.member_found = true
            $scope.member_deleted = $scope.member.meta_.deleted
          },
          // error handler
          function () {
            if ($location.path().indexOf('applications') > 0) {
              $scope.application_not_found = true
              $scope.utils.setPageTitle(_('members_application_not_found'))
            } else {
              $scope.member_not_found = true
              $scope.utils.setPageTitle(_('members_member_not_found'))
            }
            a4.restErrorFactory($scope)
          },
        )
      } else {
        $scope.member = new Member()
        $scope.member.meta_ = {}
        a4.loaded($scope)
        $scope.utils.setPageTitle(_('members_add_new'))
        // Set new member defaults
        $scope.member.active = true
        $scope.member_found = true
      }

      // Retrieve all the fields for generating the form.
      $scope.fields = Field.query(
        {id: 'all'},
        // success handler
        function () {
          a4.loaded($scope)
        },
        // error handler
        a4.restErrorFactory($scope),
      )

      $scope.groups = Group.query(
        {id: 'all'},
        function () {
          a4.loaded($scope)
        },
        // error handler
        a4.restErrorFactory($scope),
      )

      $scope.pre_save = function () {
        a4.trimMemberFields($scope)

        // Don't allow deleting of your own email
        if ($scope.session.user.id === $scope.member.id && !$scope.member.email) {
          alert(_('members_cannot_delete_own_email'))
          $scope._sending = false
          return false
        }

        // NB! DUPLICATE in updreqs.js
        if ($scope.passwordStrength) {
          if ($scope.passwordStrength.strength > 0) {
            if ($scope.member.newPassword_ === $scope.member.confirmNewPassword_) {
              $scope.member.password = $scope.member.newPassword_
            } else {
              alert(_('passwords_dont_match'))
              $scope._sending = false
              return false
            }
          } else {
            alert(_('insufficient_password_strength'))
            $scope._sending = false
            return false
          }
        }
        // else: passwordStrength is null - we are not setting/changing the password

        return true
      }

      $scope.save_bypass_required = function () {
        $scope.member.bypass_required_fields = true
        if ($scope.member.meta_ && $scope.member.meta_.pending) {
          $scope.approve()
        } else {
          $scope.save()
        }
      }

      // member_form is passed in from the template because the form lives in an ng-if
      // child scope. Remember it, since save_bypass_required() re-enters from the modal
      // where the form is out of scope.
      $scope.save = a4.saveFactory($scope, function (member_form) {
        $scope._member_form = member_form || $scope._member_form

        if ($scope.pre_save()) {
          $scope.member.$save(
            {id: $scope.member.id},
            // Success
            function () {
              // Avoid the "unsaved changes" prompt on the route change below.
              // unsavedChangesWarning also unbinds on the form's native submit event, but
              // that never fires because ng-disabled disables the button mid-click.
              if ($scope._member_form) {
                $scope._member_form.$dirty = false
              }

              if ($routeParams.id) {
                $scope.notify.set($scope, _('HTML_notification_member_edited'))
              } else {
                $scope.notify.set($scope, _('HTML_notification_member_added'))
              }
              $location.path(CONFIG.url.members.all())
            },
            // Fail
            function (data) {
              $scope.handleRequirednessError(data)
            },
          )
        }
      })

      $scope.send_membercard = function () {
        if (!$scope.member.phone) {
          alert(_('members_cannot_send_membercard'))
          return false
        }
        $location.path(CONFIG.url.membercard.create())
      }

      $scope.cancel = function () {
        this.member_form.$dirty = false // avoid "are you sure you want to leave this form without saving" prompt
        var path
        if ($scope.member.meta_.deleted) {
          path = CONFIG.url.members.deleted()
        } else if ($scope.member.meta_.pending) {
          path = CONFIG.url.members.applications()
        } else {
          path = CONFIG.url.members.all()
        }
        $location.path(path)
      }

      // See save() above for why member_form is passed in and remembered.
      $scope.approve = function (member_form) {
        $scope._sending = true
        $scope._member_form = member_form || $scope._member_form

        if ($scope.pre_save()) {
          Member.approve(
            {},
            $scope.member,
            // success handler
            function (/* data */) {
              // Clear the dirty flag only once the approval went through, so unsaved edits
              // still warn on navigation if it failed.
              if ($scope._member_form) {
                $scope._member_form.$dirty = false
              }

              $scope.notify.set($scope, _('HTML_notification_member_application_approved'))
              $location.path(CONFIG.url.members.applications())
            },
            // error handler
            function (data) {
              $scope.handleRequirednessError(data)
            },
          )
        }
      }

      // Restore a member, id parameter only from undo link (which has no form)
      $scope.restore = function (id, member_form) {
        if ($scope._sending) {
          return
        }
        $scope._sending = true

        if (!$scope.pre_save()) {
          return
        }

        // Override the member from the edit controller scope when called from the 'undo' link
        if (id) {
          $scope.member = {
            id: id,
          }
        }

        Member.restore(
          {},
          $scope.member,
          // success handler
          function (data) {
            // Avoid the "unsaved changes" prompt on the route change below.
            if (member_form) {
              member_form.$dirty = false
            }

            $scope.notify.set($scope, _('HTML_notification_member_restored'))
            if (id) {
              $route.reload()
            } else {
              $location.path(CONFIG.url.members.all())
            }
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      }

      $scope['delete'] = function () {
        var fullname_ = $scope.member.fullname_
        var pending = $scope.member.meta_.pending ? true : false
        var confirm_txt = pending ? _('js_member_reject_confirm') : _('js_member_delete_confirm')
        if (confirm(confirm_txt + ' ' + $scope.member.fullname_ + '?')) {
          Member['delete'](
            {
              id: $scope.member.id,
              pending: pending,
            },
            $scope.member,
            // success handler
            function (data) {
              var note = pending
                ? _('HTML_notification_member_application_rejected')
                : _('HTML_notification_member_deleted', {id: $scope.member.id, name: fullname_})
              $scope.notify.set($scope, note)
              $location.path(pending ? CONFIG.url.members.applications() : CONFIG.url.members.all())
            },
            // error handler
            a4.restErrorFactory($scope),
          )
        }
      }
    }],
  )

angular
  .module('members')
  .controller('MemberBulkEditCtrl', ['$scope', '$rootScope', '$location', '$routeParams', 'Member', 'Field', 'Group', function ($scope, $rootScope, $location, $routeParams, Member, Field, Group) {
    $scope.utils.setPageTitle(_('breadcrumb_members'))
    $scope.utils.setPageID('members')

    $scope.isAdmin = true

    var filter = $.parseJSON($routeParams.filter)

    // Retrieve all the fields for generating the form.
    $scope.fields = Field.query(
      {id: 'all'},
      // success handler
      function () {
        a4.loaded($scope)
      },
      // error handler
      a4.restErrorFactory($scope),
    )

    $scope.groups = Group.query(
      {id: 'all'},
      function () {
        a4.loaded($scope)
      },
      // error handler
      a4.restErrorFactory($scope),
    )

    $scope.member_found = true

    Member.bulkget(
      {
        filter: filter,
      },
      // success handler
      function (data) {
        $scope.bulkdata = data
      },
      // error handler
      a4.restErrorFactory($scope),
    )

    $scope.bulkfield_hash = {}
    $scope.member = {}

    $scope.uneditable_fields = ['firstname', 'lastname', 'email', 'password', 'site_admin', 'phone']

    /* Called from the Edit / Cancel buttons passing in the field name */
    $scope.toggleEdit = function (input_name) {
      $scope.bulkfield_hash[input_name].editing = !$scope.bulkfield_hash[input_name].editing
      $scope.toggleElement(input_name)
      $scope.toggleEditButton(input_name)
    }

    /* Toggle element state, including setting defaults, and hiding the elements for non-text fields */
    $scope.toggleElement = function (input_name) {
      var element = $scope.bulkfield_hash[input_name].element
      var field_type = $scope.bulkfield_hash[input_name].type

      // Pressing 'Edit'
      if ($scope.bulkfield_hash[input_name].editing) {
        // Add an empty value to the member (so that there is the option to empty a field)
        if (field_type == 'radio') {
          $scope.member[input_name] = $scope.bulkfield_hash[input_name].original
        } else if (field_type == 'checkbox') {
          $scope.member[input_name] = false
        } else {
          $scope.member[input_name] = null
        }

        // Empty the placeholder
        if (field_type == 'text') {
          element.find('.form-control').attr('placeholder', '')
        }
        // For checkboxes redisplay the input and hide the static text
        else if (field_type == 'checkbox' || field_type == 'select' || field_type == 'radio') {
          element.find('.bulk-hide').show()
          element.find('.bulk-static').hide()
        }
      }
      // Pressing 'Cancel'
      else {
        // Remove value from member
        delete $scope.member[input_name]

        // For text inputs show the value as placeholder
        if (field_type == 'text') {
          element.find('.form-control').attr('placeholder', $scope.bulkfield_hash[input_name].originalDisplay)
        }
        // For checkboxes hide the input and show the text
        else if (field_type == 'checkbox' || field_type == 'select' || field_type == 'radio') {
          element.find('.bulk-hide').hide()
          element.find('.bulk-static').show()
        }
      }
    }

    $scope.toggleEditButton = function (input_name) {
      var $button = $scope.bulkfield_hash[input_name].element.find('.btn-bulkedit')
      var _prevLabel = $button.attr('data-alt-label')
      var _currentLabel = $button.find('.text').text()
      $button.attr('data-alt-label', _currentLabel)
      $button.find('.text').text(_prevLabel)
      $button.toggleClass('btn-info btn-warning')
    }

    $scope.bulkupdate = function (member_form) {
      if (confirm(_('bulkedit_confirm_msg'))) {
        Member.bulkupdate(
          {
            data: $scope.member,
            filter: filter,
          },
          function (data) {
            // Avoid the "unsaved changes" prompt on the route change below.
            if (member_form) {
              member_form.$dirty = false
            }

            $scope.notify.set($scope, _('HTML_notification_bulkedit', {_n: data.num_updated}))
            $location.path(CONFIG.url.members.all())
          },
          a4.restErrorFactory($scope),
        )
      }
    }

    $scope.hasPendingUpdates = function () {
      var count = $.map($scope.member, function (n, i) {
        return i
      }).length
      return count > 0
    }

    $scope.getFieldLabel = function (name) {
      var ret
      if (name == 'active') {
        ret = _('bulkedit_summary_active')
      }

      angular.forEach($scope.fields, function (val, k) {
        if (val.name == name) {
          ret = val.label
        }
      })
      angular.forEach($scope.groups, function (val, k) {
        if (val.name == name) {
          ret = val.label
        }
      })

      return ret
    }

    $scope.getFieldType = function (name) {
      for (var i = 0; i <= $scope.fields.length - 1; i++) {
        if ($scope.fields[i].name === name) {
          return $scope.fields[i].type
        }
      }
    }

    $scope.getFieldSummary = function (name) {
      function _is_group() {
        for (var i = 0; i <= $scope.groups.length - 1; i++) {
          if ($scope.groups[i].name === name) {
            return true
          }
        }
        return false
      }

      var _label = $scope.getFieldLabel(name)
      var _type = $scope.getFieldType(name)
      var _val = $scope.member[name]
      if (_val === null) {
        _val = _('bulkedit_empty')
      }
      var _summary

      // Active field
      if (name == 'active') {
        _summary = _('HTML_bulk_summary_active_' + _val)
      }

      // Groups
      else if (_is_group()) {
        if (_val) {
          _summary = _('HTML_bulk_summary_group_added', {group: _label})
        } else {
          _summary = _('HTML_bulk_summary_group_removed', {group: _label})
        }
      }

      // Checkboxes
      else if (_type == 'checkbox') {
        if (_val) {
          _summary = _('HTML_bulk_summary_checkbox_checked', {field: _label})
        } else {
          _summary = _('HTML_bulk_summary_checkbox_unchecked', {field: _label})
        }
      }
      // Date formatting
      else if (_type == 'date') {
        _summary = _('HTML_bulk_edit_field_update', {field: _label, val: _.date(_val)})
      }

      // All other fields
      else {
        _summary = _('HTML_bulk_edit_field_update', {field: _label, val: _val})
      }

      return _summary
    }

    $scope.cancel = function () {
      this.member_form.$dirty = false // avoid "are you sure you want to leave this form without saving" prompt
      $location.path(CONFIG.url.members.all())
    }
  }])

angular.module('members').controller('MemberDashboardCtrl', ['$scope', '$rootScope', '$location', 'Member', function ($scope, $rootScope, $location, Member) {
  Member.stats(
    {
      filter: [
        {field: 'active', verb: 'a4boolequals', value: 'yes'},
        // Dirty hack to fetch msg stats for the dashboard
        {field: 'in_dashboard_', verb: 'a4boolequals', value: 'yes'},
      ],
    },
    // success handler
    function (data) {
      $scope.stats = data.stats
      $rootScope.member_dashboard_ok = true
    },
    // error handler
    a4.restErrorFactory($scope),
  )
}])

angular
  .module('members')
  .controller('MemberHistoryCtrl', ['$scope', 'Member', '$route', '$timeout', '$location', '$routeParams', function ($scope, Member, $route, $timeout, $location, $routeParams) {
    $scope.utils.setPageTitle(_('breadcrumb_members'))
    $scope.utils.setPageID('members')

    $scope.historyView = true
    $scope.historyDetailsOpen = {} // {441: true, 442: true}
    $scope.optinet_admin = D4GLOBALS.Grants.OptinetAdmin

    // Get basic info about the person
    Member.get(
      {id: $routeParams.id, any_state: true},
      // success handler
      function (member) {
        $scope.member = member
        a4.loaded($scope)
      },
      // error handler
      a4.restErrorFactory($scope),
    )

    Member.member_history(
      {
        id: parseInt($routeParams.id),
      },
      function (data) {
        $scope.member_history = data
        // List of fixed fields so that we can dynamically add a label for legacy items.
        // NB: This list is also on api/a4/models.py
        const fixedlabelKeys = new Set([
          'firstname',
          'lastname',
          'email',
          'email_porg1',
          'email_porg2',
          'password',
          'address_street',
          'address_city',
          'address_zip',
          'phone',
          'site_admin',
          'board',
          'everyone',
          'active',
        ])
        // Add fixedfield/empty label to legacy items that don't have it
        $scope.member_history.forEach((entry) => {
          if (!$scope.historyDetailsAvailable(entry.context)) {
            return
          }
          if (entry.data && Array.isArray(entry.data)) {
            entry.data.forEach((item) => {
              if (!('label' in item)) {
                item.label = fixedlabelKeys.has(item.field) ? `fixedlabel_${item.field}` : _('history_label_missing')
              }
            })
          }
        })
        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )

    $scope.historyDetailsAvailable = function (context) {
      return ['PersonInsert', 'PersonUpdate', 'PersonUpdateme'].includes(context)
    }

    $scope.toggleHistoryDetails = function (history_id) {
      // console.warn(history_id)
      $scope.historyDetailsOpen[history_id] = !$scope.historyDetailsOpen[history_id]
    }

    const order = ['field', 'label', 'old', 'new']
    $scope.translateLabel = function (i) {
      return _('history_data_' + order[i])
    }
    $scope.translateValue = function (data, idx) {
      function formatValue(val, field) {
        if (val === null) {
          return ''
        } else if (val === true) {
          return field === 'active' ? _('history_data_active') : _('history_data_true')
        } else if (val === false) {
          return field === 'active' ? _('history_data_inactive') : _('history_data_false')
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
          return _.date(val)
        }
        return val
      }
      const key = order[idx]
      const value = formatValue(data[key], data.field)
      // Add ' (jäsenryhmä)' suffix when the field is a group
      const suffix =
        key === 'label' && (['site_admin', 'board', 'everyone'].includes(data.field) || data.field.startsWith('g_'))
          ? _('history_data_group')
          : ''
      return key === 'label' && typeof value === 'string' && value.startsWith('fixedlabel_')
        ? _(value) + suffix
        : value + suffix
    }
  }])
